<template>
	<div id="may-savings-promotion">
		<hr class="my-16" />
		<h4 class="font-body text-xl font-medium">May Savings promotion</h4>

		<div class="mt-8 space-y-5 font-body text-lg">
			<ul class="li-padding-left space-y-5 pl-5">
				<li>
					Offer valid for new subscribers aged 21+ in NSW, QLD, and
					VIC.
				</li>
				<li>
					Promotion period: 1 May 2025, 12:01 AM AEST – 31 May 2025,
					11:59 PM AEST.
				</li>
				<li>
					Limited to the first 100 new subscriptions placed during the
					promotional period.
				</li>
				<li>Eligible only on vehicles with a $0 upfront fee.</li>
				<li>
					Offer is non-transferable, non-redeemable for cash, and
					limited to one subscription per person.
				</li>
				<li>Swaps not included.</li>
				<li>
					Cannot be used with other promotions, except for the
					refer-a-friend program.
				</li>
				<li>Swaps are not included.</li>
				<li>
					Fleet and tools-of-trade subscriptions excluded carbar
					reserves the right to verify and disqualify fraudulent
					entries Standard subscription fees and terms apply.
				</li>
			</ul>
		</div>
	</div>
</template>
